import * as React from 'react';
import { connect } from 'react-redux';

import ChannelMetricsIG from './ChannelMetricsIG';
import ChannelMetricsYT from './ChannelMetricsYT';
import ChannelMetricsTT from './ChannelMetricsTT';

import type { IndustryBenchmark, Metrics, Organization, StatisticsAudienceScore } from 'types';

type OwnProps = {
  metrics: Metrics,
  channelType: 'instagram' | 'youtube' | 'tiktok',
  benchmarksResource: IndustryBenchmark,
  isFreemium: boolean | null | undefined,
  hasRecentPosts: boolean
};

type StateProps = {
  audienceCredibility: StatisticsAudienceScore | undefined | null,
  audienceReachabilityScore: StatisticsAudienceScore | undefined | null,
  currentOrganization: Organization | undefined | null,
  minPostAgeInDays?: number
};

type Props = OwnProps & StateProps;

const ChannelMetrics: React.FunctionComponent<Props> = (props: Props) => {
  const {
    metrics,
    channelType,
    audienceCredibility,
    audienceReachabilityScore,
    currentOrganization,
    benchmarksResource,
    isFreemium,
    hasRecentPosts,
    minPostAgeInDays
  } = props;
  const isSpecialTempInfluencer = window.app.env.FEATURE_FACEBOOK_LOGIN;

  if (Object.keys(metrics).length === 0) {
    return null;
  }

  switch (channelType) {
    case 'instagram':
      return (
        <ChannelMetricsIG
          minPostAgeInDays={minPostAgeInDays}
          hasRecentPosts={hasRecentPosts}
          metrics={metrics}
          benchmarksResource={benchmarksResource}
          isFreemium={isFreemium}
          audienceCredibility={audienceCredibility}
          audienceReachabilityScore={audienceReachabilityScore}
          currentOrganization={currentOrganization}
          isSpecialTempInfluencer={isSpecialTempInfluencer}
        />
      );
    case 'youtube':
      return (
        <ChannelMetricsYT
          metrics={metrics}
          isSpecialTempInfluencer={isSpecialTempInfluencer}
        />
      );
    case 'tiktok':
      return (
        <ChannelMetricsTT
          metrics={metrics}
          currentOrganization={currentOrganization}
          isFreemium={isFreemium}
          isSpecialTempInfluencer={isSpecialTempInfluencer}
        />
      );
    default:
      return null;
  }
};

const mapStateToProps = ({
  influencerAudienceData,
  organizations,
  runtimeConfig
}): StateProps => ({
  minPostAgeInDays: runtimeConfig.config?.minPostAgeInDays,
  currentOrganization: organizations.currentOrganization,
  audienceReachabilityScore: influencerAudienceData.data.audienceReachabilityScore || null,
  audienceCredibility: influencerAudienceData.data.audienceCredibility || null
});

export default connect(mapStateToProps)(ChannelMetrics);
